import React, { useState, ReactNode } from 'react';
import { ReactComponent as PlusIcon } from '../../assets/icons/plus.svg';
import { ReactComponent as MinusIcon } from '../../assets/icons/minus.svg';
import styles from './Accordion.module.scss';

interface AccordionProps {
  header: ReactNode;
  children: ReactNode;
  defaultOpen?: boolean;
}

export function Accordion({
  header,
  children,
  defaultOpen = false
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={styles.accordion}>
      <div className={styles.header}>
        {header}
        <div
          className={styles.toggle}
          onClick={() => setIsOpen(!isOpen)}
          aria-expanded={isOpen}
        >
          {isOpen ? <MinusIcon /> : <PlusIcon className={styles.icon} />}
        </div>
      </div>
      {isOpen && <div className={styles.content}>{children}</div>}
    </div>
  );
}
